import axiosPost from '../axiosPost';

export const tiposDeDocumentoGet = async (arg) => {
    const body = {
        "service": "TipoDeDocumentoGet",
        "params": {}
    }

    try {
        const result = await axiosPost('Y', body, arg)
        return result.data.result
    } catch (err) {
        console.log(err)
    }
};